<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GRZM8f/tc-custom/9781504041003.jpg?1726519051802" alt="This image is the cover for the book Blind Ambition"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blind Ambition
      </h1>
      <p class="bookDescription body article font2">
        <b>A six-month <i>New York Times</i> bestseller: “Not only the best Watergate book, but a very good book indeed” (<i>The</i><i> Sunday Times</i>).</b><br/><br/> As White House counsel to Richard Nixon, a young John W. Dean was one of the primary players in the Watergate scandal—and ultimately became the government’s key witness in the investigations that ended the Nixon presidency. After the scandal subsided, Dean rebuilt his career, first in business and then as a bestselling author and lecturer. But while the events were still fresh in his mind, he wrote this remarkable memoir about the operations of the Nixon White House and the crisis that led to the president’s resignation.<br/>  <br/> Called “fascinating” by <i>Commentary</i>, which noted that “there can be little doubt of [Dean's] memory or his candor,” <i>Blind Ambition</i> offers an insider’s view of the deceptions and machinations that brought down an administration and changed the American people’s view of politics and power. It also contains Dean’s own unsparing reflections on the personal demons that drove him to participate in the sordid affair. Upon its original publication, <i>Kirkus Reviews</i> hailed it “the flip side of <i>All the President’s Men</i>—a document, a minefield, and prime entertainment.”<br/>  <br/> Today, Dean is a respected and outspoken advocate for transparency and ethics in government, and the bestselling author of such books as <i>The Nixon Defense</i>, <i>Worse Than Watergate</i>, and <i>Conservatives Without Conscience</i>. Here, in <i>Blind Ambition</i>, he “paints a candid picture of the sickening moral bankruptcy which permeated the White House and to which he contributed. His memory of who said what and to whom is astounding” (<i>Foreign Affairs</i>).<br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John W. Dean
      </h2>
      
      <p class="authorDescription body article">John W. Dean (b. 1938) served as White House counsel for President Richard Nixon from 1970 to 1973. During the Watergate scandal, his Senate testimony helped lead to Nixon&rsquo;s resignation. Dean has written about Watergate in his <I>New York Times</I> bestsellers <I>Blind Ambition</I> and <I>The Nixon Defense</I>. Among his fourteen other books are the national bestsellers <I>Worse Than Watergate</I>, <I>Conservatives Without Conscience</I>, and <I>Broken Government</I>. A retired investment banker, Dean is now a columnist, commentator, and teacher in a continuing legal education program for attorneys, the Watergate CLE. Most recently, Dean held the Barry Goldwater Chair of American Institutions at Arizona State University. He is currently consulting on a Watergate television series under development for ABC Entertainment.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29b4d1fa